
export default {

  methods: {

    set_LocalValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems[0]))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.tube      = json.tube
      this.schedule  = json.schedule
      this.sundries  = json.sundries

      this.tube.color = this.rawData.DELTA_CUM >= 0 ? 'SkyBlue' : 'Pink'
    },
    
      
  }
}